import { screens } from '@/tailwind.config';

export function getBreakpointFlags() {
  const width = window.innerWidth;

  return {
    isBelowSm: width < screens.sm,
    isSmAndUp: width >= screens.sm,
    isMdAndUp: width >= screens.md,
    isLgAndUp: width >= screens.lg,
    isXlAndUp: width >= screens.xl,
    isXxlAndUp: width >= screens.xxl,
  };
}
